export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
  label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    sortable: true,
    sortField: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'totalConversation',
    label: 'field.conversation',
  },
  {
    key: 'satification',
    label: 'field.satification',
  },
  {
    key: 'responseTime',
    label: 'field.responseTime',
  },
  {
    key: 'percentage',
    label: 'field.percentage',
  },
];
